<div class="wallboardViewSlide" ngCloak>
    Scorecard Slide: {{wvf?.Slides[wvf.CurrentSlide].SlideName}}
</div>